<template>

    <div v-show="show" class="bee_sgin_base_dialog_layout" @click="doClose()">


        <div class="bee_task_dialog_layout">

            <div class="bee_task_success_layout" @click.stop="doc()">


                <!-- <div class="icon_app_top_img" /> -->

                <div class="bee_content_suceess_main">

                    <div class="check_in_top">

                        <div class="dialog_title">Check-in</div>

                        <p class="dialog_intro">Congratulations, you've earned
                            <span style="color: #FFAC13;">{{ xp_String }}</span>
                            XP
                        </p>
                    </div>
                    <div class="icon_check_icon_img" ></div>



                    <div class="w_r_bg">
                        <div class="check_ll_sp">
                            <div class="check_ll_ct">
                                <div class="check_time">{{ all_time }}</div>
                                <div class="check_intor">Total Check-in</div>
                            </div>
                            <div class="check_ll_ct">
                                <div class="check_time">{{ all_xp }}</div>
                                <div class="check_intor">Total XP</div>
                            </div>
                        </div>
                        <signView :taskList="taskList"></signView>

                        <div v-if="!isTodaySign" class="p_layout">
                            <div v-if="!isClick" class="dialog_send" @click.stop="doCheckin()">
                                Check-in
                            </div>
                            <div v-else class="nuload_dialog_send">
                                <div class="loading_logo"></div>
                            </div>

                        </div>
                        <div v-else class="nu_dialog_send">
                            Check-in
                        </div>
                    </div>


                </div>
            </div>

            <div class="dialog_close_layout">

                <div class="icon_app_close_img" @click.stop="doClose()" ></div>

            </div>
        </div>


    </div>


</template>

<script>

import Toast from "../../components/message.js";
import icon_sign from '../../assets/checkIN-XP.png';
import signView from './sign.vue'
import { addEmit, resultEmitEvent } from "../../util/event.js";
import {
    baseUrl
} from "../../util/mock.js"
export default {
    name: 'signDialog',
    components: { signView },
    props: {
        taskList: [],
        isTodaySign: false,

    },

    emits: ["show", "cancel"],

    data() {
        return {
            isClick: false,
            show: false,
            xp_String: "0",
            all_xp: "0",
            all_time: "0",
            signIcon: "",
            // taskList: [
            //     {
            //         "day": 1,
            //         "xp": 1,
            //         "checked": true
            //     },
            //     {
            //         "day": 2,
            //         "xp": 1,
            //         "checked": true
            //     },
            //     {
            //         "day": 3,
            //         "xp": 2,
            //         "checked": true
            //     },
            //     {
            //         "day": 4,
            //         "xp": 3,
            //         "checked": true
            //     },
            //     {
            //         "day": 5,
            //         "xp": 5,
            //         "checked": true
            //     },
            //     {
            //         "day": 6,
            //         "xp": 8,
            //         "checked": true
            //     },
            //     {
            //         "day": 7,
            //         "xp": 13,
            //         "checked": true
            //     },
            //     {
            //         "day": 8,
            //         "xp": 21,
            //         "checked": true
            //     },
            //     {
            //         "day": 9,
            //         "xp": 34,
            //         "checked": false
            //     },
            //     {
            //         "day": 10,
            //         "xp": 55,
            //         "checked": false
            //     }
            // ]
        }
    },

    watch: {

    },

    methods: {
        doc() {
            // console.log("===doc===")
        },
        doContet() {
            // console.log("===doContet===")
        },
        doClose() {
            this.show = false;
        },
        showDialog(xp, all_xp, all_time) {
            this.xp_String = xp;
            this.all_xp = all_xp;
            this.all_time = all_time;
            this.show = true;
        },

        async doCheckin() {
            this.isClick = true;
            // console.log("doCheckin");
                                    var e_mail = "";
            var userData = localStorage.getItem("bee_user_login_status", null);
            if (userData != null && userData != undefined) {
                const user = JSON.parse(userData);
                e_mail = user.user.email;
            }
            const options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: new URLSearchParams({
                    action: 'bee_checkin',
                    userInfo: e_mail,
                }),
            };
            const userInfoData = await fetch(`${baseUrl()}/wp-admin/admin-ajax.php`, options)
            // console.log(userInfoData);
            let r_data = await userInfoData.json()
            let wp_data = r_data.data.data;
            let json = JSON.parse(wp_data);
            if (json.data == true) {
                addEmit("doCheckin");
            } else {
                Toast("Check-in failed " + json.message, "error");
            }
        },


    },

    mounted() {
        this.signIcon = icon_sign;

    },


}

</script>

<style scoped>
.icon_app_top_img {
    width: 115px;
    height: 115px;
    margin-bottom: -40px;
    background-image: url("../../assets/icon_task_success.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}



.h_layout {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.input_css {
    min-height: 32px;
    border: none;
    outline: none;
    border-width: 1px;
    border-color: gray;
    border-radius: 8px;
    min-width: 60%;
}

.bee_sgin_base_dialog_layout {
    position: fixed;
    z-index: 3000;
    transition: transform 700ms;
    background: rgba(0, 0, 0, 0.60);
    width: 100vw;
    height: 100vh;
}

.bee_task_dialog_layout {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
}

.bee_task_success_layout {
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
}


.bee_content_suceess_main {
    border-radius: 12px;
    /* background: linear-gradient(90deg, #FAFFEF 0%, #FFF4E2 100%); */
    background: #fff;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
}

.dialog_send {
    border-radius: 50px;
    background: #ffc04d;
    color: #FFF;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    line-height: 38px;
    /* 166.667% */
    letter-spacing: 0.12px;
    height: 38px;
    margin-top: 24px;
    width: -webkit-fill-available;
    width: -moz-available;
    cursor: pointer;
}

.nu_dialog_send {
    border-radius: 50px;
    background: #FFDF9B;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    line-height: 38px;
    /* 166.667% */
    letter-spacing: 0.12px;
    height: 38px;
    margin-top: 24px;
    width: -webkit-fill-available;
    width: -moz-available;
}

.nuload_dialog_send {
    border-radius: 50px;
    background: #FFDF9B;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    line-height: 38px;
    /* 166.667% */
    letter-spacing: 0.12px;
    height: 38px;
    margin-top: 24px;
    width: -webkit-fill-available;
    width: -moz-available;
    justify-content: center;
    display: flex;
}

.dialog_title {
    color: #812D15;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-top: 4px;
}

.dialog_intro {
    color: #666;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 4px;
    display: none;
}

.dialog_msg {
    color: #999;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 26px;
}

.dialog_close_layout {
    display: flex;
    flex-direction: row;
    margin-bottom: -30px;
    margin-top: 16px;

}

.icon_app_close_img {
    width: 28px;
    height: 28px;
    background-image: url("../../assets/icon_dialog_close.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
}

.icon_check_icon_img {
    width: 100px;
    height: 100px;
    background-image: url("../../assets/checkIN-XP.png");
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
}


.checkin_xp {
    width: 134px;
    height: 98px;
}

.check_ll_sp {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: -webkit-fill-available;
    width: -moz-available;
    margin-top: 14px;
    display: none;
}

.check_ll_ct {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.check_time {
    color: #812D15;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.check_intor {
    color: #999;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 4px;
}

.w_r_bg {
    display: flex;
    flex-direction: column;
    width: -webkit-fill-available;
    width: -moz-available;
    background: #fff;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    align-items: center;
    padding-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
}

.check_in_top {
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    margin-left: 16px;
    margin-right: 16px;
}

.empty_view {
    width: 100vw;
    height: 100vh;
    position: absolute;
    bottom: 0;
}

.loading_logo {
    width: 18px;
    height: 18px;
    background-image: url("../../assets/icon_loading.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-top: 10px;
    animation: rotate 2s linear infinite;
}

.p_layout {
    display: flex;
    width: -webkit-fill-available;
    width: -moz-available;
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>